import axios from 'axios';
import Encrypt from './../util/encrypt';

let APICallingService = {
    navigate: null,
    loginAlert: false,
    sendRequestForPostWithAuth: (Url, payload, isToken, CB) => {

        let localstorageLR = localStorage.getItem("L_R");
        let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
        let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';

        let options = {};
        if (payload != null && payload != '') {
            if (isToken) {
                options = {
                    method: 'POST',
                    url: Url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    timeout: 10000 * 3,
                    data: payload
                };
            }
            else {
                options = {
                    method: 'POST',
                    url: Url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': loginResponse?.token?.accessToken,
                        'idToken': loginResponse?.token?.idToken,
                    },
                    timeout: 10000 * 3,
                    data: payload
                };
            }

        }
        try {
            return axios(options).then(response => {
                let responseOK = response && response.status == 200;
                if (responseOK) {
                    CB({ callBackStatus: 'Success', data: response.data ? response.data : '' });
                    return { callBackStatus: 'Success', data: response.data ? response.data : '' };
                }
                else {
                    CB({
                        status: 'Failed',
                        error: response.data
                    })
                }

                CB({ callBackStatus: 'Failed' });
                return { callBackStatus: 'Failed' };
            }).catch(e => {

                if (e?.response?.status && (e?.response?.status == 405)) {

                    if (!APICallingService.loginAlert) {
                        APICallingService.loginAlert = true;
                        alert('Please login again');
                        localStorage.clear();
                        window.location.replace('/');
                        return;
                    }

                }
                else {
                    CB({ callBackStatus: 'Failed' });
                    return { callBackStatus: 'Failed' };
                }
            })
        } catch (e) {
            if (e?.response?.status && (e?.response?.status == 405)) {

                if (!APICallingService.loginAlert) {
                    APICallingService.loginAlert = true;
                    alert('Please login again');
                    localStorage.clear();
                    window.location.replace('/');
                    return;
                }
            }
            else {
                CB({ callBackStatus: 'Failed' });
                return { callBackStatus: 'Failed' };
            }
        }
    },

    sendRequestForGet: (url, CB) => {

        let localstorageLR = localStorage.getItem("L_R");
        let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
        let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';
        let options = {};
        options = {
            method: 'GET',
            url: url,
            timeout: 10000 * 3,
            headers: {
                'Authorization': loginResponse?.token?.accessToken,
                'idToken': loginResponse?.token?.idToken,
            },
        }
        try {
            return axios(options).then(response => {
                let responseOK = response && response.status == 200;
                if (responseOK) {
                    CB({ callBackStatus: 'Success', data: response.data, Status: response?.status });
                    return { callBackStatus: 'Success', data: response.data, Status: response?.status };
                }
                if (response?.status && (response?.status == 405)) {
                    if (!APICallingService.loginAlert) {
                        APICallingService.loginAlert = true;
                        alert('Please login again');
                        localStorage.clear();
                        window.location.replace('/');
                        return;
                    }
                }
                else {
                    return {
                        status: 'Failed',
                        error: response?.data,
                        Status: response?.status
                    }
                }
            }).catch(e => {
                if (e?.response?.status && (e?.response?.status == 405)) {

                    if (!APICallingService.loginAlert) {
                        APICallingService.loginAlert = true;
                        alert('Please login again');
                        localStorage.clear();
                        window.location.replace('/');
                        return;
                    }

                }
                else {
                    CB({ callBackStatus: 'Failed', Status: e?.response?.status });
                    return { callBackStatus: 'Failed', Status: e?.response?.status };
                }

            })
        } catch (e) {
            if (e?.response?.status && (e?.response?.status == 405)) {

                if (!APICallingService.loginAlert) {
                    APICallingService.loginAlert = true;
                    alert('Please login again');
                    localStorage.clear();
                    window.location.replace('/');
                    return;
                }
            }
            else {
                CB({ callBackStatus: 'Failed', Status: e?.response?.status });
                return { callBackStatus: 'Failed', Status: e?.response?.status };
            }
        }
    },

    sendRequestForPut: (payload, url, CB) => {
        let localstorageLR = localStorage.getItem("L_R");
        let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
        let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';

        let options = {
            method: 'PUT',
            url: url,
            timeout: 10000 * 3,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': loginResponse?.token?.accessToken,
                'idToken': loginResponse?.token?.idToken,
            },
            data: payload
        };
        try {
            return axios(options).then(response => {
                let responseOK = response && response.status == 200;
                if (responseOK) {
                    CB({ callBackStatus: 'Success', data: response.data });
                    return ({ callBackStatus: 'Success', data: response.data });;
                }
                return {
                    status: 'Failed',
                    error: response.data
                }
            }).catch(e => {

                if (e?.response?.status && (e?.response?.status == 405)) {

                    if (!APICallingService.loginAlert) {
                        APICallingService.loginAlert = true;
                        alert('Please login again');
                        localStorage.clear();
                        window.location.replace('/');
                        return;
                    }

                }
                else {
                    CB({ callBackStatus: 'Failed' });
                    return { callBackStatus: 'Failed', error: e?.response?.data.error, status: e?.response?.status };
                }
            })
        } catch (e) {
            if (e?.response?.status && (e?.response?.status == 405)) {

                if (!APICallingService.loginAlert) {
                    APICallingService.loginAlert = true;
                    alert('Please login again');
                    localStorage.clear();
                    window.location.replace('/');
                    return;
                }

            }
            else {
                CB({ callBackStatus: 'Failed' });
                return { callBackStatus: 'Failed' };
            }
        }
    },

};

export default APICallingService;